const App = {
    InitLazyLoad: () => {
        return new LazyLoad({
            elements_selector: ".lazyload"
        });
    }
}
function height(el) {
    var height = 0;
    $(el).each(function () {
        var thisHeight = $(this).height();
        if (thisHeight > height) {
            height = thisHeight;
        }
        setTimeout(() => {
            $(el).height(height)
        }, 100)
    })
}
let header = {
    scrollActive: function () {
        let height = $('header').height()
        if ($(window).scrollTop() > height) {
            $('header').addClass('active')
        } else {
            $('header').removeClass('active')
        }
    },
}

$(document).on('scroll', function () {
    header.scrollActive()
})

function LanguageToggle() {
    $('header .main-language .dropdown-toggle').on('click', function () {
        $('header .main-language .dropdown-menu').slideToggle()
    })
}

function SearchToggle() {
    $('header .main-search .button-search').on('click', function (e) {
        if ($('header .searchbox').css('opacity') == 0) {
            $('header .searchbox').addClass('active')
            $('header .backdrop').addClass('active')
        } else if ($('header .searchbox').css('opacity') == 1) {
            $('header .searchbox').removeClass('active')
        }
        $('header .main-language .dropdown-menu').slideUp()
        $('header .backdrop').on('click', function () {
            $('header .backdrop').removeClass('active')
            $('header .searchbox').removeClass('active')
        })
        e.stopPropagation();
    })
}

function mapping() {
    $("header .menu").mapping({
        mobileWrapper: "header .mobile-wrap",
        mobileMethod: "appendTo",
        desktopWrapper: "header .main-menu",
        desktopMethod: "appendTo",
        breakpoint: 1025
    });
    $("header .main-language .dropdown-menu .item").mapping({
        mobileWrapper: "header .mobile-wrap .menu",
        mobileMethod: "insertAfter",
        desktopWrapper: "header .main-language .dropdown-menu",
        desktopMethod: "appendTo",
        breakpoint: 576
    });
}

function ClickButtonMenuMobile() {
    $('header .button-hambuger').on('click', function () {
        if ($('header .button-hambuger .burger-bt-inner span').css('opacity') == 1) {
            $('header .button-hambuger').addClass('close')
            $('header .mobile-wrap').addClass('active')
            // $('header .backdrop').addClass('active')
        } else if ($('header .button-hambuger .burger-bt-inner span').css('opacity') == 0) {
            $('header .button-hambuger').removeClass('close')
            $('header .mobile-wrap').removeClass('active')
        }
    })
}

function BannerHomeSlide() {
    return new Swiper('.twg-banner-home .swiper-container', {
        // loop: true,
        speed: 1000,
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: '.twg-banner-home .swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.twg-banner-home .button-next',
            prevEl: '.twg-banner-home .button-prev',
        }
    })
}

function Home4Slide() {
    return new Swiper('.twg-home-4 .swiper-container', {
        speed: 1000,
        autoplay: {
            delay: 5000,
        },
        slidesPerView: 4,
        spaceBetween: 30,
        breakpoints: {
            576: {
                slidesPerView: 1,
                spaceBetween: 20
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 20
            },
            1140: {
                slidesPerView: 4,
                spaceBetween: 30
            },
        },
        navigation: {
            nextEl: '.twg-home-4 .button-next',
            prevEl: '.twg-home-4 .button-prev',
        },
    })
}

function BannerSilde() {
    return new Swiper('.twg-banner-breadcrumd .swiper-container', {
        loop: true,
        speed: 1000,
        autoplay: {
            delay: 5000,
        }
    })
}
let AboutNav = {
    clickToScroll: () => {
        $('.twg-nav-about ul li').on('click', function () {
            $('.twg-nav-about ul li').removeClass('active')
            $(this).addClass('active')
            let active = $(this).attr('data-nav')
            let offset = $('section[data-section=' + active + ']').offset().top - $('header').height() - $('.twg-nav-about').height()
            $("html, body").animate({
                scrollTop: offset
            }, 1000);
        })
    },
    checkMenuScroll: () => {
        var scrollTop = $(window).scrollTop(),
            header = $('header').outerHeight(),
            offset = $('.twg-nav-about').offset().top
        if (((offset - header) - scrollTop) <= 0) {
            $('.twg-nav-about').addClass('active').css({
                "top": (header - 1) + "px"
            })
        } else {
            $('.twg-nav-about').removeClass('active').removeAttr('style')
        }
    },
    scrollActive: () => {
        $('.twg-nav-about ul li').each(function () {
            let active = $(this).attr('data-nav')
            let offset = $('section[data-section=' + active + ']').offset().top - $('header').height() - $('.twg-nav-about').height() - 100
            if ($(window).scrollTop() >= offset) {
                $('.twg-nav-about ul li').removeClass('active')
                $(this).addClass('active');
            }
        });
    },
    showNav: () => {
        $('.twg-nav-about .nav-mobile').on('click', function () {
            $('.twg-nav-about .nav-mobile').toggleClass('active')
            // $('.twg-nav-about .nav-mobile').addClass('active')
            $('.twg-nav-about .main-wrap').slideToggle()
        })
    },
    init: () => {
        if ($('.twg-nav-about').length > 0) {
            AboutNav.scrollActive()
            AboutNav.clickToScroll()
        }
        AboutNav.showNav()
    }
}
$(document).on('scroll', function () {
    if ($('.twg-nav-about').length > 0) {
        AboutNav.scrollActive()
        AboutNav.checkMenuScroll()
    }
})

function AboutSlide4() {
    return new Swiper('.twg-about-4 .swiper-container', {
        loop: true,
        speed: 1000,
        spaceBetween: 30,
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: '.twg-about-4 .swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.twg-about-4 .swiper-next',
            prevEl: '.twg-about-4 .swiper-prev',
        },
    });
}

function ProjectDetailSlide() {
    var galleryThumbs = new Swiper('.twg-project-detail .slide-project-top .swiper-thumbs-bottom .gallery-thumbs', {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });
    var galleryTop = new Swiper('.twg-project-detail .slide-project-top .gallery-top', {
        spaceBetween: 10,
        navigation: {
            nextEl: '.twg-project-detail .slide-project-top .swiper-next',
            prevEl: '.twg-project-detail .slide-project-top .swiper-prev',
        },
        thumbs: {
            swiper: galleryThumbs
        }
    });
}

function ProjectDetailOtherSlide() {
    return new Swiper('.twg-project-detail .main-content-bottom .swiper-container', {
        slidesPerView: 4,
        spaceBetween: 30,
        autoplay: {
            delay: 5000,
        },
        navigation: {
            nextEl: '.twg-project-detail .main-content-bottom .swiper-next',
            prevEl: '.twg-project-detail .main-content-bottom .swiper-prev',
        },
        breakpoints: {
            576: {
                slidesPerView: 1,
                spaceBetween: 30
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 30
            },
            1025: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 30
            },
        }
    });
}

function LVHDSDetailSlide() {
    return new Swiper('.twg-linh-vuc-ct-2 .slide-lvct-2 .swiper-container', {
        slidesPerView: 3,
        spaceBetween: 30,
        autoplay: {
            delay: 5000,
        },
        navigation: {
            nextEl: '.twg-linh-vuc-ct-2 .slide-lvct-2 .swiper-next',
            prevEl: '.twg-linh-vuc-ct-2 .slide-lvct-2 .swiper-prev',
        },
        breakpoints: {
            576: {
                slidesPerView: 1,
                spaceBetween: 30
            },
            1025: {
                slidesPerView: 2,
                spaceBetween: 30
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 30
            },
        }
    });
}

function ShareNewsSocial() {
    $("#sharenews").jsSocials({
        showLabel: false,
        showCount: false,
        shares: [{
            share: "twitter",
            logo: "fab fa-twitter"
        }, {
            share: "facebook",
            logo: "fab fa-facebook-f"
        }]
    });
}

function PrintNews() {
    $('.twg-news-detail .main-news-detail .share .print').click(function () {
        window.print();
        return false;
    });
}

function changeIframe() {
    $(document).on('click', '.twg-lien-he .twg-maps li', function() {
        $('.twg-lien-he .twg-maps li').removeClass('active')
        $(this).addClass('active')
        var data = $(this).attr('data-iframe')
        $('#custom-maps iframe').attr('src', data)
    })
    $('#custom-maps iframe').attr('src', $('.twg-lien-he .twg-maps li').eq(1).attr('data-iframe'))
}
function FormApplySlideToggle() {
    $('.twg-tuyen-dung-ct .button-ung-tuyen .online a').on('click', function(e){
        e.preventDefault()
        $('.twg-tuyen-dung-ct .main-form-apply').slideToggle()
    })
}

function createSwiperElementMobile() {
    let e = "<div class=\'swiper-container\'><div class=\'swiper-wrapper\'></div></div><div class=\'main-button\'><div class=\'swiper-prev\'><em class=\'mdi mdi-arrow-left\'></em></div><div class=\'swiper-next\'><em class=\'mdi mdi-arrow-right\'></em></div></div>"
    $('.twg-news-detail .news-other-mobile').append(e)
    $('.twg-news-detail .news-other .item').each(function() {
        let i = '<div class=\'swiper-slide\'>' + this.outerHTML + '</div>'
        $('.twg-news-detail .swiper-wrapper').append(i)
    })
    return new Swiper('.twg-news-detail .swiper-container', {
        speed: 1000,
        autoplay: {
            delay: 4500
        },
        spaceBetween: 10,
        navigation: {
            prevEl: '.twg-news-detail .swiper-prev',
            nextEl: '.twg-news-detail .swiper-next',
        },
    })
}
function slideToggleNavChild(){
    $('.twg-nav .nav-mobile').on('click', function(){
        $('.twg-nav .nav-mobile').toggleClass('active')
        $('.twg-nav-about .nav-mobile').addClass('active')
        $('.twg-nav .main-wrap').slideToggle()
    })
}
function changeHrefLogoAVG() {
    if (window.location.href.indexOf("/en-US") > -1) {
        $('header .main-wrap .left-wrap a').attr('href', '/en-US/Default.aspx')
    } else {
        $('header .main-wrap .left-wrap a').attr('href', '/')
    }
}
$(document).ready(function () {
    App.InitLazyLoad()

    LanguageToggle()
    SearchToggle()
    mapping()
    ClickButtonMenuMobile()

    // About Nav Scroll
    AboutNav.init()

    // slide banner
    BannerHomeSlide()
    BannerSilde()
    // AboutNav.init()

    // swiper slide
    Home4Slide()
    AboutSlide4()
    ProjectDetailSlide()
    ProjectDetailOtherSlide()
    LVHDSDetailSlide()

    //share
    ShareNewsSocial()
    //Print
    PrintNews()

    // Change Iframe
    changeIframe()
    //Change href
    changeHrefLogoAVG()
    
    // Form Apply
    FormApplySlideToggle()


    createSwiperElementMobile()
    // lazyload
    // var myLazyLoad = new LazyLoad({
    //     elements_selector: ".lazyload",
    //     load_delay: 300
    // });
    // lazyload()
    slideToggleNavChild()
})